import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconPatients from 'components/icons/IconPatients';

const styles = () => ({
  root: {
    height: 330,
  },
  iconPatients: {
    width: 90,
    height: 105,
  },
  typographyBody: {
    textAlign: 'center',
    margin: '16px 16px 0 16px',
  },
});

const СlaimsTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={0}
  >
    <Grid item>
      <IconPatients className={classes.iconPatients} />
    </Grid>
    <Grid item>
      <Typography className={classes.typographyBody} variant="subheading" color="secondary">
        Unfortunately, there are no claims with such name
      </Typography>
    </Grid>
  </Grid>
);

СlaimsTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconPatients: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(СlaimsTableEmpty);



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsTable/ClaimsTableEmpty.js